import { HttpClient } from '@angular/common/http';
import { Component, HostListener, OnInit } from '@angular/core';
import { DialogService } from "ngx-bootstrap-modal";

import { HeaderMainData } from './header-main-data';
import { HeaderMenuComponent } from '../header-menu/header-menu.component';
import { WindowCloseDirective } from '../../utility/window-close.directive';
import { CommonStorageKey } from '../../const/common-storage-key';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html'
})

export class HeaderComponent implements OnInit {
  visible: boolean = true;

  public headerMainData:HeaderMainData;

  constructor(private http: HttpClient, private dialogService: DialogService) {
    this.headerMainData = new HeaderMainData();
    //// タブ複製対応
    //if (sessionStorage.getItem(CommonStorageKey.SESHONID) === null) {
    //  window.open('about:blank', '_self').close();
    //  return;
    //}
  }

  showDialog() {
    const headerInfoNameWidth = document.getElementById("headerInfoName").clientWidth;
    sessionStorage.setItem('N5024HeaderInfoName', headerInfoNameWidth.toString());
    this.dialogService.addDialog(HeaderMenuComponent);
  }

  ngOnInit() {
    this.headerMainData.userName = sessionStorage.getItem(CommonStorageKey.YUZAMEISHO) + '　様';
    // 課題No3 start
    // 前回ログイン日時 start
    let zenkaiLoginNitiji = sessionStorage.getItem(CommonStorageKey.ZENKAIROGUINNICHIJI);

    if (zenkaiLoginNitiji.length >= 12) {
      this.headerMainData.zenkaiLoginNitiji = zenkaiLoginNitiji.substring(0, 4) + "/" + zenkaiLoginNitiji.substring(4, 6) + "/" +
        zenkaiLoginNitiji.substring(6, 8) + " " + zenkaiLoginNitiji.substring(8, 10) + ":" + zenkaiLoginNitiji.substring(10, 12);
      // ST-346 start
    } else {
      this.headerMainData.zenkaiLoginNitiji = "----/--/-- --:--";
      // ST-346 end
    }

    // 課題No3 end
    this.showTime();
  }

  @HostListener('window:unload') unloadHandler() {
    // 移転の場合、子画面を閉じない。
    if (WindowCloseDirective.itenFlg) {
      WindowCloseDirective.itenFlg = false;
      return;
    }
    // 親画面を閉じる場合、子画面も閉じる。
    if (WindowCloseDirective.winList !== null && WindowCloseDirective.winList.length > 0) {
      for (let i = 0; i < WindowCloseDirective.winList.length; i++) {
        const winItem = WindowCloseDirective.winList[i];
        if (!winItem.closed) {
          winItem.close();
        }
      }
    }
  }

  showTime() {
    this.http.post('/GetHeaderTime', { responseType: 'text' }).subscribe(result => {
      // ST-403 Start
      //let secCnt: number;
      //secCnt = + result.toString();
      //this.timeUpdate(secCnt);
      let secCnt: number;
      secCnt = + result.toString();
      let date = new Date();
      let timecnt: number = (date.getHours() * 3600) + (date.getMinutes() * 60);
      sessionStorage.setItem(CommonStorageKey.TIMERADD, (secCnt - timecnt).toString());
      this.timeUpdate();
      // ST-403 End
    }, error => console.error(error));
  }

  // ST-403 Start
  //timeUpdate(secCnt: number) {
  //  let hours: number;
  //  let minutes: number;
  //  hours = Math.floor(secCnt / 3600);
  //  minutes = Math.floor((secCnt - hours * 3600) / 60);
  //  const Hours = hours < 10 ? '0' + hours : hours;
  //  const Minutes = minutes < 10 ? '0' + minutes : minutes;
  //  this.headerMainData.headTime = Hours + '：' + Minutes;
  //  secCnt = secCnt + 1;
  //  setTimeout(() => { this.timeUpdate(secCnt) }, 1000);
  //}

  timeUpdate() {
    let timeadd = 0;
    if (sessionStorage.getItem(CommonStorageKey.TIMERADD) !== null) {
      timeadd = Number(sessionStorage.getItem(CommonStorageKey.TIMERADD));
    }
    let date = new Date();
    let timecnt: number = (date.getHours() * 3600) + (date.getMinutes() * 60) + timeadd;
    let hours: number;
    let minutes: number;
    hours = Math.floor(timecnt / 3600);
    minutes = Math.floor((timecnt - hours * 3600) / 60);
    const Hours = hours < 10 ? '0' + hours : hours;
    const Minutes = minutes < 10 ? '0' + minutes : minutes;
    this.headerMainData.headTime = Hours + '：' + Minutes;
    setTimeout(() => { this.timeUpdate() }, 1000);
  }
  // ST-403 End
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/component/header/header.component.ts